<template>
  <div class="home-leads page-wrapper">
    <div class="container-xl">
      <!-- Page title -->
      <div class="page-header d-print-none">
        <div class="row align-items-center">
          <div class="col">
            <h2 class="page-title" v-if="leadOrder">Lead Order: {{ leadOrder.name }}</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="page-body">
      <div class="container-xl" v-if="loaded && leadOrder">
        <div class="row row-deck row-cards">
          <div class="col col-lg-2">
            <div class="w-100">
              <router-link class="btn btn-sm" :to="`/lead-orders`">
                <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-narrow-left"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 12l14 0" /><path d="M5 12l4 4" /><path d="M5 12l4 -4" /></svg>
                Back to Orders
              </router-link>
              <!-- Page pre-title -->
              <div class="page-pretitle mt-3">
                {{ $auth.activeCompany.companyName }}
              </div>           
              <div class="mb-3">
                <div><strong>Cost per Lead: </strong>{{ leadOrder.bid }}</div>
                <div><strong>Start Date: </strong>{{ formatDate(leadOrder.startDate) }}</div>
                <div v-if="leadOrder.isComplete"><strong>Complete Date: </strong>{{ formatDate(leadOrder.completeDate) }}</div>
              </div>
              <div class="subheader mb-2">Export</div>
              <div class="mb-3">
                <button
                  class="btn btn-primary"
                  @click.prevent="generateCSV()"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-table-export"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path
                      d="M11.5 20h-5.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v7.5m-16 -3.5h16m-10 -6v16m4 -1h7m-3 -3l3 3l-3 3"
                    ></path>
                  </svg>
                  Download as CSV
                </button>
              </div>
            </div>
            <div v-if="reload">
              <div class="spinner-border mt-2" role="status"></div>
            </div>
          </div>
          <div class="col-lg-10">
            <div class="container-xl" v-if="leadDTOs.length > 0">
              <div class="row">
                <div class="col">
                  <div class="d-flex justify-content-end align-items-end">
                    <div class="subheader lead-count" id="topOftable">
                      {{ leadDTOs.length }} Leads
                    </div>
                    <a type="button" @click.prevent="collapseAll()" class="btn btn-link">
                      Collapse all
                    </a>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="card">
                    <div class="table-responsive">
                      <table
                        class="table table-vcenter card-table table-striped"
                      >
                        <thead>
                          <tr>
                            <th>
                              <a href="#">
                                Lead Date (EST)
                              </a>
                            </th>
                            <th class="text-left text-nowrap">
                              <a href="#">
                                Lead Type
                              </a>
                            </th>
                            <th class="text-left text-nowrap">
                              <a href="#"
                                >First Name</a
                              >
                            </th>
                            <th class="text-left text-nowrap">
                              <a href="#"
                                >Last Name</a
                              >
                            </th>
                            <th class="text-left">
                              <a href="#">Title</a>
                            </th>
                            <th class="text-left">
                              <a href="#"
                                >Company</a
                              >
                            </th>
                            <th class="text-left text-nowrap">
                              <a href="#"
                                >Email Address</a
                              >
                            </th>
                            <th class="text-left text-nowrap"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <template  v-for="leadDTO in leadDTOs">
                            <tr
                              v-bind:key="leadDTO.rowid"
                            >
                              <td>
                                <div class="text-left text-nowrap">
                                  {{ leadDTO.sentDate }}
                                </div>
                              </td>
                              <td>
                                <div class="text-left text-nowrap">
                                  {{ leadDTO.reportLeadType }}
                                </div>
                              </td>
                              <td>
                                <div class="text-left text-nowrap">
                                  {{ leadDTO.leadFirstName }}
                                </div>
                              </td>
                              <td>
                                <div class="text-left text-nowrap">
                                  {{ leadDTO.leadLastName }}
                                </div>
                              </td>
                              <td>
                                <div class="text-left">
                                  {{ leadDTO.leadTitle }}
                                </div>
                              </td>
                              <td>
                                <div class="text-left">
                                  {{ leadDTO.leadCompanyName }}
                                </div>
                              </td>
                              <td>
                                <div class="text-left">
                                  {{ leadDTO.leadEmailAddress }}
                                </div>
                              </td>
                              <td>
                                <svg @click.prevent="toggleDto(leadDTO)" v-if="leadDTO.isOpen && leadDTO.leadEmailMessage != null && leadDTO.leadEmailMessage.length > 0" xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-chevron-down interactive"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M6 9l6 6l6 -6" /></svg>
                                <svg @click.prevent="toggleDto(leadDTO)" v-if="leadDTO.isOpen === false && leadDTO.leadEmailMessage != null && leadDTO.leadEmailMessage.length > 0" xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-chevron-up interactive"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M6 15l6 -6l6 6" /></svg>
                              </td>
                            </tr>
                            <tr v-if="leadDTO.isOpen && leadDTO.leadEmailMessage != null && leadDTO.leadEmailMessage.length > 0" v-bind:key="leadDTO.rowid">
                              <td colspan="8">
                                <div class="html-container">{{ leadDTO.leadEmailMessage }}</div>
                              </td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="container-xl" v-else>
              <span>
                This lead order does't have any leads yet.
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="container-xl" v-else-if="loaded && !leadOrder">
        <div class="row">
          <div class="col">
            <h3>We could not find this order under the selected company</h3>
          </div>
        </div>
      </div>
      <div class="container-xl" v-else>
        <div class="row">
          <div class="col">
            <h3>Preparing lead order details...</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.table .text-right {
  text-align: right;
}
.table .text-left {
  text-align: left;
}
.table .text-center {
  text-align: center;
}
.table-responsive {
  margin-bottom: 0px;
}

.home-leads{
  min-height: calc(100vh - 200px);
}

.interactive{
  cursor: pointer;
}

.html-container{
  white-space: pre-wrap;
}

.lead-count{
  margin-bottom: 8px;
}

</style>

<script>
import LeadOrderService from "../../services/LeadOrderService";
import CSVService from "../../services/CSVService";
import TrackingService from "../../services/TrackingService";
import { format, parseISO } from "date-fns"; //parseISO format isBefore

export default {
  name: "LeadOrderLeads",
  components: {
  },
  data: () => {
    return {
      loaded: false,
      reload: false,
      leadDTOs: [],
      leadOrder: null,
      custom: false,
      rows: 0,
    };
  },
  methods: {
    formatDate(date) {
      if(!date) return "";
      return format(parseISO(date), "MM/dd/yyyy");
    },
    toggleDto(dto){
      dto.isOpen =!dto.isOpen;
    },
    collapseAll(){
      this.leadDTOs.forEach(dto => dto.isOpen = false);
    },
    generateCSV() {
      TrackingService.track("download lead order lead export", {
        detail: `lead order id: ${this.leadOrder.id}`,
      });
      let fields = [
        {
          id: "LeadDateEST",
          getter: (r) => r["sentDate"],
        },
        {
          id: "LeadType",
          getter: (r) => r["reportLeadType"],
        },
        {
          id: "FirstName",
          getter: (r) => r["leadFirstName"],
        },
        {
          id: "LastName",
          getter: (r) => r["leadLastName"],
        },
        {
          id: "Title",
          getter: (r) => r["leadTitle"],
        },
        {
          id: "EmailAddress",
          getter: (r) => r["leadEmailAddress"],
        },
        {
          id: "Company",
          getter: (r) => r["leadCompanyName"],
        },
        {
          id: "CompanySize",
          getter: (r) => r["leadNumberOfEmployees"],
        },
        {
          id: "Industry",
          getter: (r) => r["leadIndustry"],
        },
        {
          id: "PhoneNumber",
          getter: (r) => r["leadPhone"],
        },
        {
          id: "Address",
          getter: (r) => r["leadAddress"],
        },
        {
          id: "Address2",
          getter: (r) => r["leadAddress2"],
        },
        {
          id: "City",
          getter: (r) => r["leadCity"],
        },
        {
          id: "State",
          getter: (r) => r["leadState"],
        },
        {
          id: "PostalCode",
          getter: (r) => r["leadPostalCode"],
        },
        {
          id: "Country",
          getter: (r) => r["leadCountry"],
        },
        {
          id: "MessageSubject",
          getter: (r) => r["leadEmailSubject"],
        },
        {
          id: "Message",
          getter: (r) => r["leadEmailMessage"],
        },
        {
          id: "Lead Order",
          getter: (r) => r["leadOrder"],
        },
        {
          id: "Lead Order Start Date (EST)",
          getter: (r) => r["leadOrderStartDate"],
        },
      ];
      let csv = CSVService.serialize({
        fields: fields,
        records: this.leadDTOs,
      });
      let download = document.createElement("a");
      let blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      let url = URL.createObjectURL(blob);
      download.href = url;
      download.setAttribute("download", "lead_export.csv");
      download.click();
    },
    async getLeadData(isreload) {
      // mark as reload or not
      this.reload = isreload;

      // make service call
      let leadDTOs = await LeadOrderService.getLeadOrderLeads(this.$route.params.id);
      this.leadOrder = await LeadOrderService.getLeadOrder(this.$route.params.id);

      leadDTOs.forEach((n) => {
        // incrment rows
        this.rows++;

        n.leadSource = n.leadSource ? n.leadSource : "";

        // format sentdate
        n.sentDate = format(parseISO(n.sendDate), "MM/dd/yyyy HH:mm:ss");

        n.leadOrder = this.leadOrder.name;
        n.leadOrderStartDate = format(parseISO(this.leadOrder.startDate), "MM/dd/yyyy");
        n.isOpen = true;//All open by default

        // build rowid
        n.rowid = this.rows;
      });

      // sort by sitename
      this.leadDTOs = leadDTOs;

      // mark as loaded
      this.loaded = true;

      // mark as reloaded
      this.reload = false;
    },
  },
  async mounted() {
    // load lead data for company
    this.getLeadData(false);
    TrackingService.track("viewed lead order leads page");
  },
};
</script>
